import React from 'react';
import { StyledHeroVirtualShowroom } from './StyledHeroVirtualShowroom';


const HeroVirtualShowroom = ({}) => {
  const heroContent = {

      "videoDesk": require('../../assets/hero-virtual.mp4'),
      "videoMobile": require('../../assets/hero-virtual.mp4')
    }
  return (
    <React.Fragment>
      {
       
          <StyledHeroVirtualShowroom>
          <div className="hero-virtual--wrap">
            <video 
                  autoPlay
                  playsInline
                  muted
                  preload="metadata" 
                  loop
                >
                  <source src={ window.innerWidth > 1023 ? heroContent.videoDesk : heroContent.videoMobile}  type="video/mp4"></source>
            </video>
            <h4 className="big--title">Create the perfect context for your content</h4>

          </div>
          </StyledHeroVirtualShowroom>
          
      }
    </React.Fragment>
  );
};

export default HeroVirtualShowroom;
